import types from './types';
import API from '../../lib/api';
import {dispatch as localDispatch} from '../../lib/store';

export const setModalAlert = alert => {
    return {
        type: types.modal_alert,
        payload: alert
    }
}

export const clearBitcoinCashout = () => {
    return {
        type: types.bitcoin_cashout,
        payload: null
    }
}

export const setModalQR = data => {
    return {
        type: types.modal_qr,
        payload: data
    }
}

export const setUser = user => {
    return {
        type: types.user,
        payload: user
    }
}

export const setBitcoinProfit = profit => {
    return {
        type: types.bitcoin_profit,
        payload: profit
    }
}

export const loadWallet = data => async dispatch => {
    const response = await API.call({
        path: '/get',
        method: 'POST',
        body: {
            data,
            bonusToken: window.localStorage.getItem('bonusToken') || ""
        }
    });

    if(!response.success)
        return window.alert(response.error);

    return dispatch({
        type: types.loaded,
        payload: {
            tasks: response.tasks || [],
            wallet: response.wallet,
            bitcoin: response.bitcoin,
            clouds: response.clouds
        }
    });
}

export const resetPayPalLinks = () => {
    return {
        type: types.paypal_links,
        payload: null
    }
}

export const getPayPalLinks = navigate => async dispatch => {
    const response = await API.call({
        path: '/getPayPalLinks',
        method: 'POST'
    });

    if(!response.success) {
        localDispatch(setModalAlert({
            type: "danger",
            title: "Error",
            text: response.error,
            button: "Close"
        }));

        return navigate('/');
    }

    dispatch({
        type: types.paypal_order,
        payload: null
    });

    return dispatch({
        type: types.paypal_links,
        payload: response.links
    });
}

export const getCashAppRecipient = navigate => async dispatch => {
    const response = await API.call({
        path: '/getCashAppRecipient',
        method: 'POST'
    });

    if(!response.success) {
        localDispatch(setModalAlert({
            type: "info",
            title: "CashApp",
            // text: response.error,
            text: "Ask the operator how to make a CashApp deposit, or choose a CashApp Cash Card to make a debit card deposit.",
            button: "Close"
        }));

        return navigate('/');
    }

    return dispatch({
        type: types.cashapp_recipient,
        payload: response.recipient
    });
}

export const clearCashAppRecipient = () => {
    return {
        type: types.cashapp_recipient,
        payload: null
    }
}

export const transaction = tx => {
    return {
        type: types.transaction,
        payload: {
            ...tx,
            status: "pending",
            timestamp: 0
        }
    }
}

export const clearPayPalOrder = () => {
    return {
        type: types.paypal_order,
        payload: null
    }
}

export const createPayPalOrder = (data, navigate) => async dispatch => {
    const response = await API.call({
        path: '/createPayPalDepositRequest',
        method: 'POST',
        body: data
    });

    if(!response.success) {
        localDispatch(setModalAlert({
            type: "danger",
            title: "Error",
            text: response.error,
            button: "Close"
        }));
        
        return navigate(-1);
    }

    dispatch({
        type: types.paypal_order,
        payload: response.order
    });
}

export const approvePayPalOrder = (paymentId, navigate) => async dispatch => {
    const response = await API.call({
        path: '/approvePayPalDepositRequest',
        method: 'POST',
        body: {
            paymentId
        }
    });

    if(!response.success) {
        localDispatch(setModalAlert({
            type: "danger",
            title: "Error",
            text: response.error,
            button: "Close"
        }));
        
        return navigate(-1);
    }

    dispatch({
        type: types.transaction,
        payload: response.transaction
    });
}

export const approveCashAppOrder = paymentId => async dispatch => {
    const response = await API.call({
        path: '/approveCashAppDepositRequest',
        method: 'POST',
        body: {
            paymentId
        }
    });

    if(!response.success) {
        return localDispatch(setModalAlert({
            type: "danger",
            title: "Error",
            text: response.error,
            button: "Close"
        }));
    }

    dispatch({
        type: types.transaction,
        payload: response.transaction
    });
}

export const approveChimeOrder = paymentId => async dispatch => {
    const response = await API.call({
        path: '/approveChimeDepositRequest',
        method: 'POST',
        body: {
            paymentId
        }
    });

    if(!response.success) {
        return localDispatch(setModalAlert({
            type: "danger",
            title: "Error",
            text: response.error,
            button: "Close"
        }));
    }

    dispatch({
        type: types.transaction,
        payload: response.transaction
    });
}

export const createSquareUpOrder = (data, navigate) => async dispatch => {
    dispatch({
        type: types.toggleButton,
        payload: 'create_square_order'
    });

    const response = await API.call({
        path: '/createSquareDepositRequest',
        method: 'POST',
        body: data
    });

    dispatch({
        type: types.toggleButton,
        payload: 'create_square_order'
    });

    if(!response.success) {
        localDispatch(setModalAlert({
            type: "danger",
            title: "Error",
            text: response.error,
            button: "Close"
        }));

        return navigate(-1);
    }

    dispatch({
        type: types.square_order,
        payload: response.order
    });

    // dispatch({
    //     type: types.transaction,
    //     payload: response.transaction
    // });
}

export const createCashAppMerchantOrder = (data, navigate) => async dispatch => {
    dispatch({
        type: types.toggleButton,
        payload: 'create_cashapp_merchant_order'
    });

    const response = await API.call({
        path: '/createCashappMerchantDepositRequest',
        method: 'POST',
        body: data
    });

    dispatch({
        type: types.toggleButton,
        payload: 'create_cashapp_merchant_order'
    });

    if(!response.success) {
        localDispatch(setModalAlert({
            type: "danger",
            title: "Error",
            text: response.error,
            button: "Close"
        }));

        return navigate(-1);
    }

    dispatch({
        type: types.cashapp_merchant_order,
        payload: response.order
    });

    // dispatch({
    //     type: types.transaction,
    //     payload: response.transaction
    // });
}

export const createPayouOrder = (data, navigate) => async dispatch => {
    dispatch({
        type: types.toggleButton,
        payload: 'create_payou_order'
    });

    const response = await API.call({
        path: '/createPayouDepositRequest',
        method: 'POST',
        body: data
    });

    dispatch({
        type: types.toggleButton,
        payload: 'create_payou_order'
    });

    if(!response.success) {
        localDispatch(setModalAlert({
            type: "danger",
            title: "Error",
            text: response.error,
            button: "Close"
        }));

        return navigate(-1);
    }

    dispatch({
        type: types.payou_order,
        payload: response.order
    });

    // dispatch({
    //     type: types.transaction,
    //     payload: response.transaction
    // });
}

export const clearPayouOrder = () => {
    return {
        type: types.payou_order,
        payload: null
    }
}

export const clearCashappMerchantOrder = () => {
    return {
        type: types.cashapp_merchant_order,
        payload: null
    }
}


export const clearSquareOrder = () => {
    return {
        type: types.square_order,
        payload: null
    }
}

export const createCashAppOrder = ({data, _}, navigate) => async dispatch => {
    dispatch({
        type: types.toggleButton,
        payload: 'cashapp_create_button'
    });

    const response = await API.call({
        path: '/createCashAppDepositRequest',
        method: 'POST',
        body: {
            ...data,
            cashtag: `$${data.cashtag}`
        }
    });

    dispatch({
        type: types.toggleButton,
        payload: 'cashapp_create_button'
    });

    if(!response.success) {
        // if(response.not_valid_cashtag)
        //     return dispatch(setModalAlert({
        //         cashtag_notfound: true,
        //         button: "Got it!"
        //     }));

        localDispatch(setModalAlert({
            type: response.tag_init ? "info" : "danger",
            title: response.tag_init ? "First Payment" : "Error",
            text: response.error,
            button: "Close"
        }));

        return;
    }

    dispatch({
        type: types.cashapp_order,
        payload: response.order
    });

    document.dispatchEvent(new CustomEvent('cashapp.stage', {detail: _}));
}

export const createChimeOrder = (data, navigate) => async dispatch => {
    dispatch({
        type: types.toggleButton,
        payload: 'chime_create_button'
    });

    const response = await API.call({
        path: '/createChimeDepositRequest',
        method: 'POST',
        body: data
    });

    dispatch({
        type: types.toggleButton,
        payload: 'chime_create_button'
    });

    if(!response.success) {
        localDispatch(setModalAlert({
            type: "danger",
            title: "Error",
            text: response.error,
            button: "Close"
        }));

        return navigate('/');
    }

    dispatch({
        type: types.chime_order,
        payload: response.order
    });
}

export const clearChimeOrder = () => {
    return {
        type: types.cashapp_recipient,
        payload: null
    }
}

export const clearCashAppOrder = () => {
    return {
        type: types.cashapp_recipient,
        payload: null
    }
}

export const clearCashAppCashout = () => {
    return {
        type: types.cashapp_cashout,
        payload: null
    }
}

export const setModalTx = tx => {
    return {
        type: types.modal_tx,
        payload: tx
    }
}

export const createCashAppCashOutRequest = (data, navigate) => async dispatch => {
    dispatch({
        type: types.toggleButton,
        payload: 'create_cashapp_cashout'
    });

    const response = await API.call({
        path: '/createCashAppCashoutRequest',
        method: 'POST',
        body: {
            ...data,
            cashtag: `$${data.cashtag}`
        }
    });

    dispatch({
        type: types.toggleButton,
        payload: 'create_cashapp_cashout'
    });

    if(!response.success) {
        localDispatch(setModalAlert({
            type: "danger",
            title: "Error",
            text: response.error,
            button: "Close"
        }));

        return navigate(-1);
    }

    dispatch({
        type: types.cashapp.request,
        payload: response.payment
    });
}

export const confirmCashappCashoutRequest = (paymentId) => async dispatch => {
    dispatch({
        type: types.toggleButton,
        payload: 'confirm_cashapp_cashout'
    });

    const response = await API.call({
        path: '/confirmCashAppCashoutRequest',
        method: 'POST',
        body: {
            paymentId
        }
    });

    dispatch({
        type: types.toggleButton,
        payload: 'confirm_cashapp_cashout'
    });

    if(!response.success) {
        localDispatch(setModalAlert({
            type: "danger",
            title: "Error",
            text: response.error,
            button: "Close"
        }));
    } else {
        dispatch({
            type: types.cashapp.confirmed
        });
    }
}

export const cancelCashAppCashoutRequest = paymentId => async dispatch => {
    dispatch({
        type: types.toggleButton,
        payload: 'cancel_cashout'
    });

    const response = await API.call({
        path: '/cancelCashappCashoutRequest',
        method: 'POST',
        body: {
            paymentId
        }
    });

    dispatch({
        type: types.toggleButton,
        payload: 'cancel_cashout'
    });

    if(!response.success) {
        localDispatch(setModalAlert({
            type: "danger",
            title: "Error",
            text: response.error,
            button: "Close"
        }));
    } else {
        localDispatch(setModalAlert({
            type: "success",
            title: "Done",
            text: response.message,
            button: "Close"
        }));
    }
}

export const claimCashback = () => async dispatch => {
    dispatch({
        type: types.toggleButton,
        payload: 'claim_cashback'
    });

    const response = await API.call({
        path: '/claimCashback',
        method: 'POST'
    });

    dispatch({
        type: types.toggleButton,
        payload: 'claim_cashback'
    });    

    if(!response.success) {
        localDispatch(setModalAlert({
            type: "danger",
            title: "Error",
            text: response.error,
            button: "Close"
        }));

        return;
    } else {
        dispatch({
            type: types.transaction,
            payload: response.transaction
        });

        dispatch({
            type: types.cashback_redeem,
            payload: response.balance
        });

        localDispatch(setModalAlert({
            type: "success",
            title: "Done",
            text: response.message,
            button: "Close"
        }));
    }
}

export const redeemHalloweenGift = giftKey => async dispatch => {
    dispatch({
        type: types.toggleButton,
        payload: 'halloween'
    });

    const response = await API.call({
        path: '/redeemHalloween',
        method: 'POST',
        body: {
            giftKey
        }
    });

    dispatch({
        type: types.toggleButton,
        payload: 'halloween'
    });

    if(!response.success) {
        window.alert(response.error);  
    } else {
        dispatch({
            type: types.modal_halloween_data,
            payload: response.gift
        });

        dispatch({
            type: types.modal_halloween,
            payload: 'redeem'
        });

        dispatch({
            type: types.halloween_gifts,
            payload: response.my_gifts
        });
    }
}

export const setHalloweenModal = modal => {
    return {
        type: types.modal_halloween,
        payload: modal
    }
}

export const confirmBitcoinCashoutRequest = (paymentId, navigate) => async dispatch => {
    dispatch({
        type: types.toggleButton,
        payload: 'confirm_bitcoin_cashout'
    });

    const response = await API.call({
        path: '/confirmBitcoinCashoutRequest',
        method: 'POST',
        body: {
            paymentId
        }
    });

    dispatch({
        type: types.toggleButton,
        payload: 'confirm_bitcoin_cashout'
    });

    if(!response.success) {
        localDispatch(setModalAlert({
            type: "danger",
            title: "Error",
            text: response.error,
            button: "Close"
        }));

        return;
    }

    dispatch({
        type: types.bitcoin_cashout_approved,
    }); 

    dispatch({
        type: types.balance,
        payload: response.balance
    }); 
}

export const initializeCashapp = (navigate) => async dispatch => {
    const response = await API.call({
        path: '/checkCashappCashout',
        method: 'POST'
    });

    if(!response.success || !response.works) {
        localDispatch(setModalAlert({
            type: "danger",
            title: "Error",
            text: "Chime is temporarily unavailable for withdrawal. Use other systems to withdraw funds",
            button: "Close"
        }));

        return navigate(-1);
    } else {
        dispatch({
            type: types.cashapp.initialized
        });
    }
}

export const resetCashapp = () => {
    return {
        type: types.cashapp.reset
    }
}

export const createBitcoinCashOutRequest = (data, navigate) => async dispatch => {
    dispatch({
        type: types.toggleButton,
        payload: 'create_bitcoin_cashout'
    });

    const response = await API.call({
        path: '/createBitcoinCashoutRequest',
        method: 'POST',
        body: data
    });

    dispatch({
        type: types.toggleButton,
        payload: 'create_bitcoin_cashout'
    });

    if(!response.success) {
        localDispatch(setModalAlert({
            type: "danger",
            title: "Error",
            text: response.error,
            button: "Close"
        }));

        return navigate('/cashout');
    }

    const isOverload = (response.order.comission.usd / response.order.total_amount.usd) > 0.07;

    if(isOverload)
        localDispatch(setModalAlert({
            type: "danger",
            title: "Bitcoin Overload",
            text: `At the moment, the Bitcoin network is heavily loaded, and therefore the blockchain charges an increased transaction processing fee.<br><br> <b>We recommend waiting a little while for the network to unload...</b>`,
            button: "Close"
        }));

    // dispatch({
    //     type: types.balance,
    //     payload: response.balance
    // });

    dispatch({
        type: types.bitcoin_cashout,
        payload: {
            ...response.order,
            status: "unconfirmed"
        }
    });
}

export const redeemTask = task_key => async dispatch => {
    dispatch({
        type: types.tasks_toggle,
        payload: task_key
    });

    const response = await API.call({
        path: '/redeemTask',
        method: 'POST',
        body: {
            key: task_key
        }
    });

    if(!response.success) {
        localDispatch(setModalAlert({
            type: "danger",
            title: "Tasks",
            text: response.error,
            button: "Got it"
        }));

        dispatch({
            type: types.tasks_toggle,
            payload: task_key
        });

        return;
    }

    localDispatch(setModalAlert({
        type: "success",
        title: "Tasks",
        text: response.message,
        button: "Okay, thanks!"
    }));

    dispatch({
        type: types.tasks,
        payload: response.tasks
    });
}

export const openVerify = () => async dispatch => {
    dispatch({
        type: types.toggleButton,
        payload: 'verification'
    });

    const response = await API.call({
        path: '/getVerificationLink',
        method: 'POST'
    });

    dispatch({
        type: types.toggleButton,
        payload: 'verification'
    });


    if(!response.success) {
        localDispatch(setModalAlert({
            type: "danger",
            title: "Verification",
            text: response.error,
            button: "Got it"
        }));

        return;
    } else {
        window.Telegram.WebApp.openLink(response.link);
    }
}
